module.exports = __webpack_public_path__ + "static/media/publish-videos-images-desktop-es.b50c294f.webp";